import { render, staticRenderFns } from "./FaqArea.vue?vue&type=template&id=6dac7249&scoped=true&"
import script from "./FaqArea.vue?vue&type=script&lang=js&"
export * from "./FaqArea.vue?vue&type=script&lang=js&"
import style0 from "./FaqArea.vue?vue&type=style&index=0&id=6dac7249&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac7249",
  null
  
)

export default component.exports